module.exports = __webpack_public_path__ + "img/mlh_honor_9.9e7304d0.png";